import { __awaiter, __generator } from "tslib";
export var BlobEncoding;
(function (BlobEncoding) {
    BlobEncoding[BlobEncoding["ArrayBuffer"] = 0] = "ArrayBuffer";
    BlobEncoding[BlobEncoding["Base64"] = 1] = "Base64";
    BlobEncoding[BlobEncoding["DataURL"] = 2] = "DataURL";
    BlobEncoding[BlobEncoding["ObjectURL"] = 3] = "ObjectURL";
    BlobEncoding[BlobEncoding["Blob"] = 4] = "Blob";
})(BlobEncoding || (BlobEncoding = {}));
var BlobConverter = /** @class */ (function () {
    function BlobConverter() {
    }
    BlobConverter.convertBlob = function (blob, encoding) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (encoding === BlobEncoding.Blob) {
                            return [2 /*return*/, blob];
                        }
                        if (encoding === BlobEncoding.ObjectURL) {
                            return [2 /*return*/, URL.createObjectURL(blob)];
                        }
                        if (encoding === BlobEncoding.ArrayBuffer) {
                            return [2 /*return*/, this.convertBlobToArrayBuffer(blob)];
                        }
                        return [4 /*yield*/, BlobConverter.convertBlobToDataURL(blob)];
                    case 1:
                        url = _a.sent();
                        if (encoding === BlobEncoding.DataURL) {
                            return [2 /*return*/, url];
                        }
                        return [2 /*return*/, url.split(',')[1]];
                }
            });
        });
    };
    BlobConverter.convertBlobToDataURL = function (blob) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        if (!reader.result) {
                            return reject(new Error('unable to transform blob to data url'));
                        }
                        resolve(reader.result);
                    };
                    reader.onabort = reject;
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })];
        });
    }); };
    BlobConverter.convertBlobToArrayBuffer = function (blob) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        if (!reader.result) {
                            return reject(new Error('unable to transform blob to array buffer'));
                        }
                        resolve(reader.result);
                    };
                    reader.onabort = reject;
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(blob);
                })];
        });
    }); };
    return BlobConverter;
}());
export { BlobConverter };
export default BlobConverter;
//# sourceMappingURL=blob-converter.js.map